import { render, staticRenderFns } from "./chatSEN.vue?vue&type=template&id=1c968b60&scoped=true"
import script from "./chatSEN.vue?vue&type=script&lang=js"
export * from "./chatSEN.vue?vue&type=script&lang=js"
import style0 from "./chatSEN.vue?vue&type=style&index=0&id=1c968b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c968b60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VIcon,VMenu,VTextField})
